/* eslint-disable import/no-named-as-default-member */
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { ButtonIcon, InputText, LabelString } from '@loanbossinc/component-library';
import styled from 'styled-components';
import { recalculateRecourseSchedule } from './testHarness.store';
import { PageContainer, TitleBar } from './styles';


const FieldWrapper = styled.div`&& {
    display:flex;
    flex-direction: row;
}`;

const StyledLabelString = styled(LabelString)`&& {
    margin-right: 26px;
    margin-top: auto;
    margin-bottom: auto;
}`;

const StyledInputText = styled(InputText)`&& {
    width: 150px;
    height:22px;
}`;


class APITestHarness extends Component {
    state = {
        recourseScheduleLoanId: null
    };


    itemChanged = (event, property) => {
        let item = this.state[property];
        item = event?.target?.value;
        this.setState({ [property]: item });
    };


    render() {
        return (
            <>
                <PageContainer>
                    <TitleBar>API HARNESS</TitleBar>
                    <FieldWrapper className="FieldWrapper">
                        <StyledLabelString value={"Loan Id"} />
                        <StyledInputText
                            placeholder="Value"
                            onChange={(event) => this.itemChanged(event, 'recourseScheduleLoanId')}
                            value={this.state.recourseScheduleLoanId}
                            variant="filled"
                        />
                        <ButtonIcon style={{ width: '80px' }} iconName="input" onClick={() => this.props.recalculateRecourseSchedule({ loanId: this.state.recourseScheduleLoanId })} />
                    </FieldWrapper>
                </PageContainer>

            </>
        );
    };
}

function mapStateToProps({ authentication }) {
    return {
        authentication
    };
}

export default compose(
    connect(
        mapStateToProps,
        {
            recalculateRecourseSchedule
        }
    ))(APITestHarness);
